import styled from 'styled-components'

export const StyledSignatureValueContainer = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: 200px 300px;
`

export const StyledActions = styled.div`
  display: flex;
  align-items: center;
`
